import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Shield } from "lucide-react";

const ScreenshotProtection = () => {
  const [userEmail, setUserEmail] = useState<string>("");

  useEffect(() => {
    // Get user email for watermark
    const getUserEmail = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (user?.email) {
        setUserEmail(user.email);
      }
    };
    getUserEmail();

    // Disable right-click context menu
    const handleContextMenu = (e: MouseEvent) => {
      e.preventDefault();
      return false;
    };

    // Disable common screenshot keyboard shortcuts
    const handleKeyDown = (e: KeyboardEvent) => {
      // PrintScreen
      if (e.key === 'PrintScreen') {
        e.preventDefault();
        alert('Screenshots are disabled for privacy protection');
        return false;
      }
      
      // Windows: Win + Shift + S (Snipping Tool)
      if (e.key === 's' && e.shiftKey && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        alert('Screenshots are disabled for privacy protection');
        return false;
      }

      // Mac: Cmd + Shift + 3/4/5
      if ((e.key === '3' || e.key === '4' || e.key === '5') && e.shiftKey && e.metaKey) {
        e.preventDefault();
        alert('Screenshots are disabled for privacy protection');
        return false;
      }

      // F12 (DevTools)
      if (e.key === 'F12') {
        e.preventDefault();
        return false;
      }

      // Ctrl+Shift+I (DevTools)
      if (e.ctrlKey && e.shiftKey && e.key === 'I') {
        e.preventDefault();
        return false;
      }
    };

    // Detect when window loses focus (might indicate screenshot)
    const handleBlur = () => {
      console.log('Window focus lost - potential screenshot attempt detected');
    };

    // Add event listeners
    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);
    window.addEventListener('blur', handleBlur);

    // Cleanup
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('blur', handleBlur);
    };
  }, []);

  return (
    <>
      {/* Watermark overlay - visible in screenshots */}
      {userEmail && (
        <div 
          className="fixed inset-0 pointer-events-none z-[9999] select-none"
          style={{
            background: `repeating-linear-gradient(
              45deg,
              transparent,
              transparent 200px,
              rgba(0, 0, 0, 0.02) 200px,
              rgba(0, 0, 0, 0.02) 400px
            )`
          }}
        >
          <div className="absolute inset-0 flex items-center justify-center opacity-5">
            <div className="text-center rotate-[-45deg] select-none">
              <Shield className="w-16 h-16 mx-auto mb-2" />
              <p className="text-2xl font-bold">{userEmail}</p>
              <p className="text-sm">© Protected Content</p>
            </div>
          </div>
        </div>
      )}

      {/* Corner watermark */}
      <div className="fixed bottom-2 right-2 opacity-20 pointer-events-none select-none z-[9999] text-xs text-muted-foreground">
        🔒 Screenshot Protected
      </div>
    </>
  );
};

export default ScreenshotProtection;
